import { StorageService } from './storage.service';
import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService implements StorageService {

  constructor() { }

  write(key: string, value: any) : void {
      if (value) {
          value = JSON.stringify(value);
      }
      localStorage.setItem(key, value);
  }

  read<TData>(key: string): TData {
      let value: string = localStorage.getItem(key);
      if (value && value != "undefined" && value != "null") {
          return <TData>JSON.parse(value);
      }
      return null;
  }
  
  /** Removes an item which corriponds to the given key. */
  remove(key: string) : void {
    localStorage.removeItem(key);
  }

  /** Verifyes if there's an item with the given key. */
  contains(key: string) : boolean{
    var item = localStorage.getItem(key);
    return item != undefined && item != null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/services/cache/local-storage.service.ts